module.exports = __webpack_public_path__ + "media/toolkits/times-octagon-light-7ea6746c.svg";